/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { IdentifierTypeVoucher } from './receipt-sale.interface';

@Injectable({
  providedIn: 'root'
})
export class ReceiptSaleService {
  private data: any;
  public receipts = IdentifierTypeVoucher;

  constructor() {
    this.data = this.receipts[0];
  }

  getData() {
    return this.data;
  }

  setData(data) {
    this.data = data;
  }
}
